"use strict";

var AccessoriesThankYouCards = require('./AccessoriesThankYouCards');

var ComponentsCards = require('./ComponentsCards');

var DoubleThickExampleCards = require('./DoubleThickExampleCards');

var EnvelopeLinerInserts = require('./EnvelopeLinerInserts');

var Information2018Cards = require('./Information2018Cards');

var InvitationThankYouCards = require('./InvitationThankYouCards');

var LetterpressSampleCards = require('./LetterpressSampleCards');

var OrderTimelineCards = require('./OrderTimelineCards');

var PackedByCards = require('./PackedByCards');

var PhotographyInserts = require('./PhotographyInserts');

var RibbonInstructions = require('./RibbonInstructions');

var RibbonSampleInstructions = require('./RibbonSampleInstructions');

var SaveTheDateThankYouCards = require('./SaveTheDateThankYouCards');

var StandardInstructions = require('./StandardInstructions');

var WhyShineCards = require('./WhyShineCards');

var CustomColorCharts = require('./CustomColorCharts');

var ColorChartLiners = require('./ColorChartLiners');

var ColorChartKits = require('./ColorChartKits');

var ColorCharts = require('./ColorCharts');

var SampleClassicInvitationSuites = require('./SampleClassicInvitationSuites');

var RibbonSampleCards = require('./RibbonSampleCards');

var LinerSamples = require('./LinerSamples');

module.exports = {
  LinerSamples: LinerSamples,
  RibbonSampleCards: RibbonSampleCards,
  SampleClassicInvitationSuites: SampleClassicInvitationSuites,
  ColorCharts: ColorCharts,
  ColorChartKits: ColorChartKits,
  ColorChartLiners: ColorChartLiners,
  CustomColorCharts: CustomColorCharts,
  WhyShineCards: WhyShineCards,
  StandardInstructions: StandardInstructions,
  SaveTheDateThankYouCards: SaveTheDateThankYouCards,
  RibbonSampleInstructions: RibbonSampleInstructions,
  RibbonInstructions: RibbonInstructions,
  PhotographyInserts: PhotographyInserts,
  PackedByCards: PackedByCards,
  OrderTimelineCards: OrderTimelineCards,
  LetterpressSampleCards: LetterpressSampleCards,
  InvitationThankYouCards: InvitationThankYouCards,
  Information2018Cards: Information2018Cards,
  EnvelopeLinerInserts: EnvelopeLinerInserts,
  DoubleThickExampleCards: DoubleThickExampleCards,
  ComponentsCards: ComponentsCards,
  AccessoriesThankYouCards: AccessoriesThankYouCards
};